"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWrapperHOC = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Factory to generate a simple component wrapper with the provided component.
 * `hocName` is necessary to set an appropriate `displayName` on the wrapper component.
 */
const createWrapperHOC = _ref => {
  let {
    WrapperComponent,
    hocName
  } = _ref;
  return ChildComponent => {
    var _a, _b;
    const withHOC = props => (0, jsx_runtime_1.jsx)(WrapperComponent, {
      children: (0, jsx_runtime_1.jsx)(ChildComponent, Object.assign({}, props !== null && props !== void 0 ? props : {}))
    });
    const wrappedComponentName = (_b = (_a = ChildComponent.displayName) !== null && _a !== void 0 ? _a : ChildComponent.name) !== null && _b !== void 0 ? _b : "Component";
    withHOC.displayName = `${hocName}(${wrappedComponentName})`;
    return withHOC;
  };
};
exports.createWrapperHOC = createWrapperHOC;